module.exports = __webpack_public_path__ + "img/energy001.d1f7abb3.png";